import Skeleton from 'react-loading-skeleton'
import {
  baseColorSkeletonDark,
  baseColorSkeletonLight,
  highlightColorSkeletonDark,
  highlightColorSkeletonLight
} from '@/frontend/utils/globalVariables'
import 'react-loading-skeleton/dist/skeleton.css'

type TextSkeletonProps = {
  height?: number
  width?: string | number
  count?: number
  dark?: boolean
  className?: string
}

export function TextSkeleton({
  height = 30,
  width = '100%',
  count = 1,
  dark = false,
  className = ''
}: TextSkeletonProps) {
  const baseColor = dark ? baseColorSkeletonDark : baseColorSkeletonLight
  const highlightColor = dark ? highlightColorSkeletonDark : highlightColorSkeletonLight

  return (
    <Skeleton
      height={height}
      width={width}
      baseColor={baseColor}
      highlightColor={highlightColor}
      count={count}
      borderRadius={16}
      className={className}
    />
  )
}
